import { useMutation } from '@tanstack/react-query';
import {
    agentRole,
  UserApiService,
} from 'features/users/api/user-api.service';



const { saveagentEventUpdateRole } = UserApiService();

export const useCreateEventAgentRole = () => {

  return useMutation(
    (payload: agentRole) => {
      return saveagentEventUpdateRole(payload);
    },
  );
};





